import api from '@/services/api/config';

const path = 'v1/asset-standard/historie/typ';

export default {
  get: () => api.get(path),
};
